import { AbstractWSService } from "@/services/socket/ws.service";
import { type WSConnection } from "@/plugins/ws.connection";
import { TruckHandler } from "@/services/socket/handler/truck.handle.service";

export class TruckService extends AbstractWSService {
  constructor(connection: WSConnection) {
    const truckReserved = new TruckHandler();

    super(connection, {
      eventHandler: (data: any) => {
        truckReserved.handleWSData(data);
      },
      recoveryHandler(lastEvent) {
        truckReserved.recoveryHandler(lastEvent);
      },
    });
  }
}
